import styled from 'styled-components';

export const CheckboxGroupContainer = styled.fieldset`
    margin: 0;
    padding: 0;
    border: 0;
`;

export const NestedGroupWrapper = styled.div`
    margin-left: ${({ theme }) => theme.designTokens.SPACING_300}px;
`;

export const CheckboxesContainer = styled.div`
    margin: ${({ theme }) => theme.designTokens.SPACING_100}px 0;
`;
